import { render } from "./SwitchSettingControl.vue?vue&type=template&id=0acf9856"
import script from "./SwitchSettingControl.vue?vue&type=script&lang=js"
export * from "./SwitchSettingControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__